import { render } from "./PsychicCard.vue?vue&type=template&id=57f2fbf4&scoped=true"
import script from "./PsychicCard.vue?vue&type=script&lang=js"
export * from "./PsychicCard.vue?vue&type=script&lang=js"

import "./PsychicCard.vue?vue&type=style&index=0&id=57f2fbf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f2fbf4"]])

export default __exports__